var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5918 48C37.8466 48 48.5918 37.2548 48.5918 24C48.5918 10.7452 37.8466 0 24.5918 0C11.337 0 0.591797 10.7452 0.591797 24C0.591797 37.2548 11.337 48 24.5918 48Z",
    fill: "url(#paint0_linear_658_5111)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4558 23.7469C18.4523 20.6986 23.1177 18.689 25.4521 17.7181C32.1171 14.9459 33.5021 14.4643 34.4048 14.4484C34.6033 14.4449 35.0472 14.4941 35.3348 14.7274C35.5776 14.9245 35.6444 15.1906 35.6763 15.3774C35.7083 15.5642 35.7481 15.9897 35.7165 16.3222C35.3553 20.1172 33.7925 29.3265 32.9974 33.577C32.661 35.3755 31.9985 35.9785 31.3572 36.0375C29.9635 36.1658 28.9052 35.1165 27.5553 34.2316C25.443 32.8469 24.2496 31.985 22.1993 30.6338C19.8297 29.0723 21.3658 28.2141 22.7162 26.8115C23.0696 26.4445 29.2104 20.859 29.3292 20.3523C29.3441 20.2889 29.3579 20.0527 29.2176 19.9279C29.0772 19.8032 28.8701 19.8459 28.7207 19.8798C28.5088 19.9279 25.1344 22.1583 18.5973 26.5709C17.6395 27.2287 16.7719 27.5491 15.9946 27.5323C15.1377 27.5138 13.4893 27.0478 12.2639 26.6495C10.7609 26.1609 9.56636 25.9026 9.67038 25.0729C9.72456 24.6407 10.3197 24.1987 11.4558 23.7469Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_658_5111",
    x1: 24.5918,
    y1: 0,
    x2: 24.5918,
    y2: 47.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/TG.6433bd47b34b461b7791a2bc54d30c6a.svg";
export { ForwardRef as ReactComponent };